import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_OTHER_RENEWABLE_ENERGY',
  GET: 'GET_OTHER_RENEWABLE_ENERGY',
  CREATE: 'CREATE_OTHER_RENEWABLE_ENERGY',
  EDIT: 'EDIT_OTHER_RENEWABLE_ENERGY',
  DELETE: 'DELETE_OTHER_RENEWABLE_ENERGY',
  DUPLICATE: 'DUPLICATE_OTHER_RENEWABLE_ENERGY',
  CLEAR_ERROR: 'CLEAR_ERROR_OTHER_RENEWABLE_ENERGY',
};

export const clearErrorOtherRenewableEnergy = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchOtherRenewableEnergyByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchOtherRenewableEnergy(pageSize, page, sorted, filtered, isPublic);
};

const searchOtherRenewableEnergy = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_OTHER_RENEWABLE_ENERGY,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listOtherRenewableEnergy = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchOtherRenewableEnergy(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createOtherRenewableEnergy = (name, energy, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('energy', energy);
  formData.set('description', description);
  if (image) formData.set('image', image, `photovoltaic_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_OTHER_RENEWABLE_ENERGY,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editOtherRenewableEnergy = (id, name, energy, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (energy) formData.set('energy', energy);
  if (typeof(description) === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `equipment_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_OTHER_RENEWABLE_ENERGY}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteOtherRenewableEnergy = solarEnergyId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_OTHER_RENEWABLE_ENERGY}${solarEnergyId}/`,
    })
      .then(() => ({ id: solarEnergyId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateOtherRenewableEnergy = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_OTHER_RENEWABLE_ENERGY}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/renewable_energy/other_renewable_energy_actions.js